import { render, staticRenderFns } from "./vqMap.vue?vue&type=template&id=52b37a1a&"
import script from "./vqMap.vue?vue&type=script&lang=js&"
export * from "./vqMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports